import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function DeleteArticle({
  selectedData,
  isDeleteLoading,
  setIsDelete = () => {},
  isDelete,
  handleDeleteArticle,
  data,
}) {
  const handleDelete = () => {
    handleDeleteArticle(data);
  };

  return (
    <ModalComp
      title="Delete Article"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setIsDelete(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isDeleteLoading}
          handleSecondaryBtn={handleDelete}
          secondaryBtnvariant="danger"
          secondaryBtnText="Delete"
        />
      }
      open={isDelete}
      setOpen={(Value) => setIsDelete(Value)}
    >
      {`Are you sure you want to delete the article named '${selectedData?.title}'`}
    </ModalComp>
  );
}

export default DeleteArticle;
